import React,{useState,useEffect} from 'react';
import FundInfoCard from '../FundInfoCard/FundInfoCard';
import './partnerFund.css'
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";

const PartnerFund = () => {
    const [partnersFundInfo, setParnterFundInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.partnerfund,
            })
            .then((response) => {
                const partnersContent = response.data.allPartners.edges[0].node;
                setParnterFundInfo(partnersContent);

            })
            .catch((error) => {
                console.error(error);
            });
    });
  

    return (
        <div className="fund-container  ">
            <div className="row pt-0 ">
                <div className="col-md-4"></div>
                <div className="col-md-8 ps-md-5 ">
                    <div className="row gy-2 gx-2  fund-mobile-pd">
                        {/* <h3  className="text-center fund-title d-none d-md-block">{partnersFundInfo?.fund_title[0]?.text}</h3> */}
                        {partnersFundInfo?.fund_info.map((fundInfo,index) => <FundInfoCard   key={index+1} index={index+1} fundInfo={fundInfo}></FundInfoCard>)}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PartnerFund;